import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { updateLeadQuality } from "../../../services/UserServices/UserService";
import {
  LEAD_QUALITY_OPTIONS,
  getLeadQualityLabel,
  isLeadQuality,
} from "../Common/LeadQuality";

const QUALITY_BUTTON_STYLES = {
  good: { backgroundColor: "#0d6efd", borderColor: "#0d6efd", color: "#fff" },
  neutral: { backgroundColor: "#198754", borderColor: "#198754", color: "#fff" },
  bad: { backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff" },
};

const LeadQualityModal = ({
  show,
  id,
  currentValue,
  taggedAt,
  hasAppsFlyer,
  table,
  onHide,
}) => {
  const initial = isLeadQuality(currentValue) ? currentValue : "";
  const [quality, setQuality] = useState(initial);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setQuality(isLeadQuality(currentValue) ? currentValue : "");
      setSubmitting(false);
    }
  }, [show, currentValue]);

  const handleSelect = async (selectedQuality) => {
    if (!isLeadQuality(selectedQuality) || submitting) return;

    setQuality(selectedQuality);
    setSubmitting(true);
    try {
      const response = await updateLeadQuality({
        userId: id,
        quality: selectedQuality,
      });
      const result = response.data?.data;
      const tagged = isLeadQuality(result?.quality)
        ? result.quality
        : selectedQuality;

      if (result?.reason === "already_sent") {
        notifyTopRight(`Already tagged as ${getLeadQualityLabel(tagged)}`);
      } else {
        notifyTopRight(`Tagged as ${getLeadQualityLabel(tagged)}`);
      }
      if (typeof table === "function") table();
      onHide();
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={submitting ? undefined : onHide} centered>
      <div className="modal-header">
        <h4 className="modal-title fs-20">Set Lead Quality</h4>
      </div>
      <div className="modal-body">
        {!hasAppsFlyer && (
          <div className="alert alert-warning py-2">
            No AppsFlyer ID — user must open the app first.
          </div>
        )}
        <div className="form-group mb-3">
          <label className="text-black font-w500">Quality</label>
          <div className="d-flex gap-3 flex-wrap mt-2 py-2">
            {LEAD_QUALITY_OPTIONS.map((opt) => {
              const isSelected = quality === opt.value;
              const color = QUALITY_BUTTON_STYLES[opt.value].borderColor;
              return (
                <div
                  key={opt.value}
                  className="flex-fill"
                  style={{
                    border: `3px solid ${isSelected ? color : "transparent"}`,
                    borderRadius: 12,
                    padding: 3,
                    background: isSelected ? `${color}22` : "transparent",
                  }}
                >
                  <button
                    type="button"
                    disabled={submitting}
                    onClick={() => handleSelect(opt.value)}
                    style={{
                      ...QUALITY_BUTTON_STYLES[opt.value],
                      width: "100%",
                      border: "none",
                      borderRadius: 8,
                      padding: "10px 16px",
                      fontWeight: 600,
                      cursor: submitting ? "not-allowed" : "pointer",
                      opacity: isSelected ? 1 : 0.85,
                    }}
                  >
                    {opt.label}
                  </button>
                </div>
              );
            })}
          </div>
          <small className="text-muted d-block mt-3">
            Current: {getLeadQualityLabel(currentValue)}
            {taggedAt
              ? ` · Tagged ${moment(taggedAt).format("DD MMM YYYY, hh:mm A")}`
              : ""}
          </small>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-danger"
          disabled={submitting}
        >
          <i className="flaticon-delete-1"></i> Cancel
        </button>
      </div>
    </Modal>
  );
};

export default LeadQualityModal;
